import {
  Directive,
  ElementRef,
  Inject,
  Input,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";

@Directive({
  selector: "img[onStock]",
  standalone: false,
})
export class ImageOnStockDirective implements OnChanges {
  el: ElementRef;

  @Input() onStock?: any = false;
  @Input() src!: string;

  constructor(
    @Inject("API_GATEWAY_URL") public gatewayUrl: string,
    private _sanitizer: DomSanitizer,
    el: ElementRef,
  ) {
    this.el = el;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes["src"]) {
      if (
        changes["src"].currentValue &&
        !changes["src"].currentValue?.startsWith("base64") &&
        !changes["src"].currentValue?.startsWith("http") &&
        changes["src"].currentValue != "defaultImagePropagate"
      ) {
        let route = this.onStock ? "files" : "images";
        let url = `${this.gatewayUrl}/onstock/${route}/${changes["src"].currentValue}`;

        this.el.nativeElement.src = url;
      } else if (changes["src"].currentValue != "defaultImagePropagate") {
        this.el.nativeElement.src = this.src;
      }
    }
  }

  sanitize(url: any): SafeUrl {
    return this._sanitizer.bypassSecurityTrustUrl(url);
  }
}
